var exports = {
  "An": "ProductAnnouncementModalVisual__J5O4ow",
  "jD": "ProductAnnouncementModalVisual__item__M7WSfl",
  "l4": "ProductAnnouncementModalVisual__item--active__Q2Lo0t",
};

module.exports = exports;
